//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { disabledDate, dateFormat } from '@/plugin/format.js'
import PictureList from '@/components/PictureList.vue'

export default {
  data () {
    return {
      filters: {
        keyword: '',
        model: '',
        seriesno: '',
        state: '待审核'
      },
      devicesdata: [],
      dataForm: {},
      total: 0,
      currentPage: 1,
      pageSize: 20,
      selectvalue: '',
      editDialogVisible: false,
      pictureVisible: false,
      rejectVisible: false,
      editLoading: false,
      rejectForm: {
        opinion: null
      },
      rejectFormRules: {
        opinion: [
          { required: true, message: '请输入审核意见', trigger: 'blur' }
        ]
      },
      dataFormRules: {
        model: [{ required: true, message: '请输入型号', trigger: 'blur' }],
        seriesno: [{ required: true, message: '请输入系列号', trigger: 'blur' }]
      },
      pickerOptions: {
        disabledDate (time) {
          return disabledDate(time)
        }
      },
      selections: [], // 列表选中列
      approvalList: [],
      rejectList: [],
      picturelist: [],
      opinion: ''
    }
  },
  methods: {
    querylist: function () {
      this.currentPage = 1
      this.getlist()
    },
    getlist: function () {
      let params = {
        UserName: 'panasonic',
        Keyword: this.filters.keyword.trim(),
        Model: this.filters.model.trim(),
        SeriesNO: this.filters.seriesno.trim()
      }
      if (this.filters.state) {
        params.State = this.filters.state
      }
      params.PageIndex = this.currentPage - 1
      params.PageSize = this.pageSize
      this.$api
        .getDeviceBypage(params)
        .then(res => {
          if (res.Status === 1) {
            this.devicesdata = res.Entity
            this.total = res.TotalRowsCount
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function (res) {
          this.$alert('获取数据错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    handleEdit: function (row) {
      this.editDialogVisible = true
      let df = Object.assign({}, row)
      this.dataForm = df
      this.rejectForm.opinion = ''
    },

    handleApproval: function () {
      this.$confirm(
        '确认审核' + this.approvalList.length.toString() + '台设备吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        var params = []
        this.approvalList.forEach(dev => {
          params.push({
            UserName: dev.UserName,
            Model: dev.Model,
            SeriesNO: dev.SeriesNO
          })
        })
        this.$api.deviceApproval(params).then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '设备注册成功',
              type: 'success'
            })

            this.getlist()
            this.uploadDialogVisible = false
          } else {
            this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleReject: function () {
      this.$refs.rejectForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '确认驳回' + this.rejectList.length.toString() + '台设备吗？',
            '提示',
            { cancelButtonClass: 'btn-custom-cancel' }
          ).then(() => {
            var params = []
            this.rejectList.forEach(dev => {
              params.push({
                UserName: dev.UserName,
                Model: dev.Model,
                SeriesNO: dev.SeriesNO,
                Opinion: this.rejectForm.opinion
              })
            })
            this.$api.deviceReject(params).then(res => {
              if (res.Status === 1) {
                this.$message({
                  message: '驳回成功',
                  type: 'success'
                })

                this.getlist()
                this.uploadDialogVisible = false
              } else {
                this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
                  confirmButtonText: '确定'
                })
              }
            })
          })
        }
      })
    },
    editReject: function () {
      this.$refs.rejectForm.validate(valid => {
        if (valid) {
          var params = []
          params.push({
            UserName: this.dataForm.UserName,
            Model: this.dataForm.Model,
            SeriesNO: this.dataForm.SeriesNO,
            Opinion: this.rejectForm.opinion
          })
          this.$api.deviceReject(params).then(res => {
            if (res.Status === 1) {
              this.$message({ message: '驳回成功', type: 'success' })
              this.editDialogVisible = false
              this.getlist()
            } else {
              this.$alert(res.Message, '错误', {
                confirmButtonText: '确定'
              })
            }
          })
        }
      })
    },
    editDelete: function () {
      this.$confirm(
        '确认删除这台设备的注册信息吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        var params = []
        params.push({
          UserName: this.dataForm.UserName,
          Model: this.dataForm.Model,
          SeriesNO: this.dataForm.SeriesNO
        })
        this.$api.deviceDeleteRegist(params).then(res => {
          if (res.Status === 1) {
            this.$message({ message: '删除成功', type: 'success' })
            this.editDialogVisible = false
            this.getlist()
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    editApproval: function () {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          var params = []
          params.push({
            UserName: this.dataForm.UserName,
            Model: this.dataForm.Model,
            SeriesNO: this.dataForm.SeriesNO,
            PDate: this.dataForm.PDate,
            Wlimit: this.dataForm.Wlimit,
            EXWLimit: this.dataForm.EXWLimit,
            Description: this.dataForm.Description
          })
          this.$api.deviceApproval(params).then(res => {
            if (res.Status === 1) {
              this.$message({ message: '审核成功', type: 'success' })
              this.editDialogVisible = false
              this.getlist()
            } else {
              this.$alert(res.Message, '错误', {
                confirmButtonText: '确定'
              })
            }
          })
        }
      })
    },
    handleSave: function () {
      let params = {
        UserName: this.dataForm.UserName,
        Model: this.dataForm.Model,
        SeriesNO: this.dataForm.SeriesNO,
        PDate: this.dataForm.PDate,
        WLimit: this.dataForm.WLimit,
        EXWLimit: this.dataForm.EXWLimit,
        Description: this.dataForm.Description
      }
      this.$api.deviceSave(params).then(res => {
        if (res.Status === 1) {
          this.$message({ message: '保存成功', type: 'success' })
          this.getlist()
        } else {
          this.$alert(res.Message, '错误', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    handleShowPicture: function (params) {
      this.pictureVisible = true
      this.$api
        .adminGetFile(params)
        .then(res => {
          if (res.Status === 1) {
            var list = []
            res.Entity.forEach(item => {
              list.push('data:image/png;base64,' + item.Contents)
            })
            this.picturelist = list
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function (res) {
          this.$alert('获取数据错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    selectionChange: function (selections) {
      this.selections = selections
      this.approvalList = []
      this.rejectList = []
      this.selections.forEach(dev => {
        if (dev.State === '待审核' && dev.PCertificate !== null) {
          this.approvalList.push(dev)
          this.rejectList.push(dev)
        }
      })
    },
    visibleChange (isVisible) {
      const isEdge = window.navigator.userAgent.includes('Edge')
      if (isEdge && !isVisible) {
        document
          .querySelectorAll('body > .el-select-dropdown.el-popper')
          .forEach((it) => it.remove())
      }
    },
    sizeChange: function (size) {
      this.pageSize = size
      this.getlist()
    },
    refreshPageRequest: function (pageNum) {
      this.currentPage = pageNum
      this.getlist()
    },
    dateFormat: function (row, column) {
      let time = dateFormat(row, column)
      return time
    }
  },
  components: {
    PictureList
  },
  mounted () {
    this.getlist()
  }
}



// WEBPACK FOOTER //
// ./src/admin/Home.vue